function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.095 3V4.25547C16.2226 4.25547 18.7445 6.77744 18.7445 9.90502H20C20 6.09895 16.9011 3 13.095 3ZM13.095 5.51094V6.76641C14.8359 6.76641 16.2336 8.16417 16.2336 9.90502H17.4891C17.4891 7.48568 15.5144 5.51094 13.095 5.51094ZM8.47534 5.653L8.03152 6.09683C6.85409 7.27257 6.19173 8.86744 6.19003 10.5314V10.5326C6.19003 13.992 9.00789 16.8099 12.4673 16.8099H12.4685C14.1325 16.808 15.7273 16.1458 16.9031 14.9684L17.3469 14.5246L14.3088 11.4864C14.7213 11.1195 14.9774 10.587 14.9782 10.0067V10.0054C14.9782 8.91734 14.0826 8.02174 12.9945 8.02174C12.4138 8.02191 11.8806 8.27848 11.5134 8.69118L8.47534 5.653ZM7.24196 15.9382L6 20.5762H13.9128L13.2299 18.0249C12.9785 18.0507 12.7247 18.065 12.4697 18.0654H12.4673C10.4423 18.0654 8.59957 17.2513 7.24197 15.9383L7.24196 15.9382Z"
});

function SvgChannel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannel);
export default __webpack_public_path__ + "static/media/channel.2e96b9e7.svg";
export { ForwardRef as ReactComponent };